export default __webpack_public_path__ + "static/media/feature-website-1.ad0801ed.png";